// A-024 Testkunde: Mail an einen Testkunden fragt einmal nach („Testkunde – wirklich senden?“).
// Der Server entscheidet (409 mit detail.testkunde); diese Funktion fragt und sendet dann mit `testkunde_ok: true` erneut.
// `senden(extra)` ruft den Sende-Weg auf und mischt `extra` in den Inhalt. Abbruch → Fehler mit `abgebrochen: true`.
export const mitTestkundeRueckfrage = async (senden) => {
  try {
    return await senden({});
  } catch (err) {
    const d = err?.response?.data?.detail;
    if (err?.response?.status === 409 && d && typeof d === "object" && d.testkunde) {
      if (window.confirm(`${d.message || "Das ist ein Testkunde – wirklich senden?"}\n\nOK = senden, Abbrechen = nicht senden`)) {
        return await senden({ testkunde_ok: true });
      }
      const abbruch = new Error("abgebrochen");
      abbruch.abgebrochen = true;
      throw abbruch;
    }
    throw err;
  }
};
